import { render, staticRenderFns } from "./NotificationQueue.vue?vue&type=template&id=2cf83390"
import script from "./NotificationQueue.vue?vue&type=script&lang=js"
export * from "./NotificationQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports